import React from 'react';
import PropTypes from 'prop-types';

const AngleDownIcon = () => {
  return (
    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="angle-down" className="svg-inline--fa" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ transition: 'all 0.3s ease 0s' }}><path fill="currentColor" d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z"></path></svg>
  );
};

AngleDownIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default AngleDownIcon;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/Header/components/AngleDownIcon/index.js
 **/